export default {
	/**
	 * notification route. (Lowercased.)  Keep routes simple; they should just fire events handled elsewhere.
	 * @route
	 */
	notifications() {
		dispatcher.trigger('notifications:routed');
	},
};
